/// <reference path="../app.ts" />
namespace Cfnc {
    "use strict";

    export interface ICampusSearchDataService {
        filterDefinition: IAvailableFilters;
        getInstitutions: () => ng.IPromise<any>;
        getInstitutionsByFilter: (any, page, pageSize, sortBy, sortAsc, occCode) => ng.IPromise<any>;
        getNCinstitutionNames: (any) => ng.IPromise<any>;
        saveCampusSearch: (SavedSearch) => ng.IPromise<boolean>
        loadSavedSearches: () => ng.IPromise<any>;
        getMajorClusters: () => ng.IPromise<any>;
    }

    export class CampusSearchDataService implements ICampusSearchDataService {
        static serviceId: string = "campusSearchDataService";
        filterDefinition: IAvailableFilters;

        constructor(private Restangular: Restangular.IService, private common: ICommonFactory, private $http: ng.IHttpService) {
            this.filterDefinition = this.createFilterDefinition();
        }

        getInstitutions(): ng.IPromise<Array<IInstitution>> {
            return this.Restangular.all("campusSearch/institutions").getList().then((result) => {
                return result;
            }, (reason) => {
                return null;
            });
        }

        getMajorClusters() {
            var deferred = this.common.$q.defer();

            return this.Restangular.all("campusSearch/majorClusters").getList().then((result) => {
                return result;
            }, (reason) => {
                return null;
            });
        }

        getInstitutionsByFilter(filter: ISearchSet, page: number = 1, pageSize: number = 10, sortBy: string = "Name", sortDesc: boolean = false, occCode = null) {
            var deferred = this.common.$q.defer();

            var searchSet: ISearchGroupSet = {
                page: page,
                pageSize: pageSize,
                sortBy: sortBy,
                sortDesc: sortDesc,
                occCode: occCode
            };

            this.Restangular.all("campusSearch/institutionFilters").post(filter, searchSet).then((result) => {
                deferred.resolve(result);
            }, (reason) => {
                deferred.reject(reason);
            });

            return deferred.promise;
        }

        getNCinstitutionNames(filter: ISearchSet) {

            var deferred = this.common.$q.defer();

            this.Restangular.all("campusSearch/institutionNames").post(filter).then((result) => {
                deferred.resolve(result);
            }, (reason) => {
                deferred.reject(reason);
            });

            return deferred.promise;
        }

        saveCampusSearch(savedSearch: SavedSearch) {
            var deferred = this.common.$q.defer<boolean>();
            var stringifiedSearch = {
                search: JSON.stringify(savedSearch.filters),
                name: savedSearch.name
            };

            this.Restangular.all("campusSearch/saveCampusSearch").post(stringifiedSearch).then((result) => {
                deferred.resolve(result);
            }, (reason) => {
                deferred.reject(reason);
            });

            return deferred.promise;
        }

        loadSavedSearches(): ng.IPromise<Array<SavedSearch>> {

            return this.Restangular.one("campusSearch/loadSavedSearches").get().then((result) => {
                return result.searches;
            }, (reason) => {
                return null;
            });
        }


        private createFilterDefinition(): IAvailableFilters {
            var filters: IAvailableFilters = {
                keyFacts: {
                    schoolType: {
                        key: "SchoolType",
                        category: "KeyFacts",
                        filters: [
                            {
                                pillText: "Two Year",
                                displayName: "Two Year",
                                key: "TwoYear"
                            }, {
                                pillText: "Four Year",
                                displayName: "Four Year",
                                key: "FourYear"
                            }, {
                                pillText: "Graduate",
                                displayName: "Graduate",
                                key: "Graduate"
                            }
                        ]
                    },
                    programType: {
                        key: "ProgramType",
                        category: "KeyFacts",
                        filters: [
                            {
                                pillText: "Certificate",
                                displayName: "Certificate",
                                key: "Certificate"
                            }, {
                                pillText: "Diploma",
                                displayName: "Diploma",
                                key: "Diploma"
                            }, {
                                pillText: "Associate",
                                displayName: "Associate",
                                key: "Associate"
                            }, {
                                pillText: "Bachelors",
                                displayName: "Bachelors",
                                key: "Bachelors"
                            }, {
                                pillText: "Masters",
                                displayName: "Masters",
                                key: "Masters"
                            }, {
                                pillText: "Doctoral",
                                displayName: "Doctoral",
                                key: "Doctoral"
                            }
                        ]
                    },
                    publicPrivate: {
                        key: "PublicPrivate",
                        category: "KeyFacts",
                        filters: [
                            {
                                pillText: "Public",
                                displayName: "Public",
                                key: "Public"
                            }, {
                                pillText: "Private/Non-Religious",
                                displayName: "Private/Non-Religious",
                                key: "Private"
                            }, {
                                pillText: "Private/Religious",
                                displayName: "Private/Religious",
                                key: "PrivateReligious"
                            }
                        ]
                    },
                    religions: {
                        key: "Religions",
                        category: "KeyFacts",
                        filters: [
                            {
                                pillText: "Adventist",
                                displayName: "Adventist",
                                key: "Adventist"
                            }, {
                                pillText: "African Methodist-Episcopal",
                                displayName: "African Methodist-Episcopal",
                                key: "AfricanMethodistEpiscopal"
                            }, {
                                pillText: "Assembly of God",
                                displayName: "Assembly of God",
                                key: "AssemblyofGod"
                            }, {
                                pillText: "Baptist",
                                displayName: "Baptist",
                                key: "Baptist"
                            }, {
                                pillText: "Christian & Missionary Alliance",
                                displayName: "Christian & Missionary Alliance",
                                key: "ChristianMissionaryAlliance"
                            }, {
                                pillText: "Christian Science",
                                displayName: "Christian Science",
                                key: "ChristianScience"
                            }, {
                                pillText: "Church of Christ",
                                displayName: "Church of Christ",
                                key: "ChurchofChrist"
                            }, {
                                pillText: "Church of God",
                                displayName: "Church of God",
                                key: "ChurchofGod"
                            }, {
                                pillText: "Church of the Brethren",
                                displayName: "Church of the Brethren",
                                key: "ChurchoftheBrethren"
                            }, {
                                pillText: "Congregational (United Church of Christ)",
                                displayName: "Congregational (United Church of Christ)",
                                key: "Congregational"
                            }, {
                                pillText: "Disciples of Christ",
                                displayName: "Disciples of Christ",
                                key: "DisciplesofChrist"
                            }, {
                                pillText: "Episcopal (Anglican)",
                                displayName: "Episcopal (Anglican)",
                                key: "Episcopal"
                            }, {
                                pillText: "Evangelical",
                                displayName: "Evangelical",
                                key: "Evangelical"
                            }, {
                                pillText: "Islamic",
                                displayName: "Islamic",
                                key: "Islamic"
                            }, {
                                pillText: "Interdenominational Christian",
                                displayName: "Interdenominational Christian",
                                key: "Interdenominational"
                            }, {
                                pillText: "Jewish",
                                displayName: "Jewish",
                                key: "Jewish"
                            }, {
                                pillText: "Lutheran",
                                displayName: "Lutheran",
                                key: "Lutheran"
                            }, {
                                pillText: "Mennonite",
                                displayName: "Mennonite",
                                key: "Mennonite"
                            }, {
                                pillText: "Methodist",
                                displayName: "Methodist",
                                key: "Methodist"
                            }, {
                                pillText: "Moravian",
                                displayName: "Moravian",
                                key: "Moravian"
                            }, {
                                pillText: "Mormon",
                                displayName: "Mormon",
                                key: "Mormon"
                            }, {
                                pillText: "Nondenominational Christian",
                                displayName: "Nondenominational Christian",
                                key: "Nondenominational"
                            }, {
                                pillText: "Other",
                                displayName: "Other",
                                key: "Other"
                            }, {
                                pillText: "Other Christian",
                                displayName: "Other Christian",
                                key: "OtherChristian"
                            }, {
                                pillText: "Plymouth Brethren",
                                displayName: "Plymouth Brethren",
                                key: "PlymouthBrethren"
                            }, {
                                pillText: "Presbyterian",
                                displayName: "Presbyterian",
                                key: "Presbyterian"
                            }, {
                                pillText: "Quaker(Society of Friends)",
                                displayName: "Quaker(Society of Friends)",
                                key: "Quaker"
                            }, {
                                pillText: "Reformed",
                                displayName: "Reformed",
                                key: "Reformed"
                            }, {
                                pillText: "Roman Catholic",
                                displayName: "Roman Catholic",
                                key: "Catholic"
                            }, {
                                pillText: "Wesleyan",
                                displayName: "Wesleyan",
                                key: "Wesleyan"
                            }
                        ]
                    },
                    campusSetting: {
                        key: "CampusSetting",
                        category: "KeyFacts",
                        filters: [
                            {
                                pillText: "Urban",
                                displayName: "Urban",
                                key: "Urban"
                            }, {
                                pillText: "Suburban",
                                displayName: "Suburban",
                                key: "Suburban"
                            }, {
                                pillText: "Small Town",
                                displayName: "Small Town",
                                key: "SmallTown"
                            }, {
                                pillText: "Rural",
                                displayName: "Rural",
                                key: "Rural"
                            }
                        ]
                    },
                    studentPopulation: {
                        key: "StudentPopulation",
                        category: "KeyFacts",
                        filters: [
                            {
                                pillText: "Population <= 2,500",
                                displayName: "Fewer than or equal to 2,500",
                                key: "XS",
                                value: "Ix1,Ix2500"
                            }, {
                                pillText: "Population between 2,501 - 5,000",
                                displayName: "2,501 - 5,000",
                                key: "S",
                                value: "Ix2501,Ix5000"
                            }, {
                                pillText: "Population between 5,001 - 10,000",
                                displayName: "5,001 - 10,000",
                                key: "M",
                                value: "Ix5001,Ix10000"
                            }, {
                                pillText: "Population between 10,001 - 15,000",
                                displayName: "10,001 - 15,000",
                                key: "L",
                                value: "Ix10001,Ix15000"
                            }, {
                                pillText: "Population between 10,001 - 15,000",
                                displayName: "15,001 - 20,000",
                                key: "XL",
                                value: "Ix15001,Ix20000"
                            }, {
                                pillText: "Population > 20,000",
                                displayName: "Greater than 20,000",
                                key: "XXL",
                                value: "Ix20001"
                            }
                        ]
                    },
                    SingleSexOrCoed: {
                        key: "SingleSexOrCoed",
                        category: "KeyFacts",
                        filters: [
                            {
                                pillText: "Men's College",
                                displayName: "Men's College",
                                key: "Mens"
                            }, {
                                pillText: "Women's College",
                                displayName: "Women's College",
                                key: "Womens"
                            }, {
                                pillText: "Coed",
                                displayName: "Coed",
                                key: "Coed"
                            }
                        ]
                    },
                    historicallyBlack: {
                        key: "HistoricallyBlack",
                        category: "KeyFacts",
                        filters: [
                            {
                                pillText: "Historically Black",
                                displayName: "Historically Black (NC only)",
                                key: "HistoricallyBlack",
                                toolTip: "Use this filter to find only Historically Black Institutions."
                            }
                        ]
                    },
                    
                        withinRangeOf: {
                            key: "WithinRangeOf",
                            category: "KeyFacts",
                            filters: [{
                                pillText: "Distance from Zipcode",
                                key: "WithinRangeOf",
                            }]
                        }, outsideRangeOf: {
                            key: "OutsideRangeOf",
                            category: "KeyFacts",
                            filters: [{
                                pillText: "Minimum Distance from Zipcode",
                                key: "OutsideRangeOf"
                            }]
                        }
                    
                },
                admissions: {
                    entranceDifficulty: {
                        key: "EntranceDifficulty",
                        category: "Admissions",
                        filters: [{
                            displayText: "Entrance Difficulty",
                            pillText: "Entrance Difficulty",
                            key: "EntranceDifficulty"
                        }]
                    }, actScores: {
                        key: "ActScores",
                        category: "Admissions",
                        filters: [{
                            pillText: "ACT Scores",
                            key: "ActScores"
                        }]
                    }, satMath: {
                        key: "SatMath",
                        category: "Admissions",
                        filter: {
                            pillText: "SAT Math Scores",
                            key: "SatMath"
                        }
                    }, satReading: {
                        key: "SatReading",
                        category: "Admissions",
                        filter: {
                            pillText: "SAT Reading Scores",
                            key: "SatReading"
                        }
                    }, satWriting: {
                        key: "SatWriting",
                        category: "Admissions",
                        filter: {
                            pillText: "SAT Writing Scores",
                            key: "SatWriting"
                        }
                    }, admissionsPolicies: {
                        key: "AdmissionsPolicies",
                        category: "Admissions",
                        filters: [
                            {
                                pillText: "Early action",
                                displayName: "Early action",
                                key: "EarlyAction",
                                toolTip: "Early Action allows students to apply and be notified of an admission decision well in advance of the regular notification dates."
                            }, {
                                pillText: "Early decision",
                                displayName: "Early decision",
                                key: "EarlyDecision",
                                toolTip: "Early Decision allows students to apply and be notified of an admission decision well in advance of  the regular notification dates.  Applicants agree to accept the offer of admission."
                            }, {
                                pillText: "Deferred admission",
                                displayName: "Deferred admission",
                                key: "DeferredAdmission",
                                toolTip: "Deferred Admission allows admitted students to postpone enrollment, usually for a period of one academic term or one year."
                            }, {
                                pillText: "Concurrent enrollment for high school",
                                displayName: "Concurrent enrollment for high school",
                                key: "ConcurrentEnrollment",
                                toolTip: "Concurrent Enrollment for High School allows high school students to take college courses while in high school."
                            }
                        ]
                    }
                },
                costAndFinancialAid: {
                    inStateTuition: {
                        key: "InStateTuition",
                        category: "CostAndFinancialAid",
                        filters: [{
                            pillText: "In-state Tuition",
                            key: "InStateTuition"
                        }]
                    },
                    outStateTuition: {
                        key: "OutStateTuition",
                        category: "CostAndFinancialAid",
                        filters: [{
                            pillText: "Out-of-state Tuition",
                            key: "OutStateTuition"
                        }]
                    },
                    financialAid: {
                        key: "FinancialAid",
                        category: "CostAndFinancialAid",
                        filters: [
                            {
                                pillText: "Academic scholarships",
                                displayName: "Academic scholarships (NC only)",
                                key: "AcademicScholarships"
                            }, {
                                pillText: "Athletic scholarships",
                                displayName: "Athletic scholarships (NC only)",
                                key: "AthleticScholarships"
                            }, {
                                pillText: "Federal work study",
                                displayName: "Federal work study",
                                key: "FederalWorkStudy"
                            }, {
                                displayName: "Federal/State grants",
                                key: "FederalStateGrants",
                                filters: [
                                    {
                                        pillText: "Federal/state grants",
                                        key: "FederalGrantsAndScholarship"
                                    },
                                    {
                                        pillText: "Federal/state grants",
                                        key: "StateGrantsAndScholarship"
                                    }
                                ]
                            }, {
                                displayName: "Federal/state grants",
                                pillText: "Federal/state grants",
                                key: "FederalGrantsAndScholarship"
                            },
                            {
                                displayName: "Federal/state grants",
                                pillText: "Federal/state grants",
                                key: "StateGrantsAndScholarship"
                            }, {
                                pillText: "Institutional grants",
                                displayName: "Institutional grants",
                                key: "InstitutionalGrants"
                            }, {
                                pillText: "Parent loans",
                                displayName: "Parent loans (NC only)",
                                key: "ParentLoans"
                            }
                        ]
                    }
                },
                academics: {
                    programsMajors: {
                        key: "ProgramsMajors",
                        category: "Academics",
                        filters: [
                            {
                                key: "AgricultureFoodandNaturalResources",
                                displayName: "Agriculture, Food and Natural Resources",
                                pillText: "Agriculture, Food and Natural Resources",
                                toolTip: "Producing, processing, marketing, distributing, financing and developing agricultural commodities and resources, including food, fiber, wood products, natural resources, horticulture and other plant and animal products and resources."
                            },
                            {
                                key: "ArchitectureAndConstruction",
                                displayName: "Architecture and Construction",
                                pillText: "Architecture and Construction",
                                toolTip: "Designing, planning, managing, building, and maintaining the built environment."
                            },
                            {
                                key: "ArtsAudioVideoTechnologyAndCommunications",
                                displayName: "Arts, Audio-Video Technology and Communications",
                                pillText: "Arts, Audio-Video Technology and Communications",
                                toolTip: "Designing, producing, exhibiting, performing, writing and publishing multimedia content, including visual and performing arts and design, journalism and entertainment services."
                            },
                            {
                                key: "BusinessManagementAdministration",
                                displayName: "Business, Management and Administration",
                                pillText: "Business, Management and Administration",
                                toolTip: "Planning, organizing, directing and evaluating business functions essential to efficient and productive business operations."
                            },
                            {
                                key: "EducationAndTraining",
                                displayName: "Education and Training",
                                pillText: "Education and Training",
                                toolTip: "Planning, managing and providing education and training services, and related learning support services."
                            },
                            {
                                key: "Finance",
                                displayName: "Finance",
                                pillText: "Finance",
                                toolTip: "Planning and providing services for financial and investment planning, banking, insurance and business financial management."
                            },
                            {
                                key: "GovernmentAndPublicAdministration",
                                displayName: "Government and Public Administration",
                                pillText: "Government and Public Administration",
                                toolTip: "Executing governmental functions including governance, national security, foreign service, planning, revenue and taxation, regulation, and management and administration at the local, state and federal levels."
                            },
                            {
                                key: "HealthScience",
                                displayName: "Health Science",
                                pillText: "Health Science",
                                toolTip: "Planning, managing and providing therapeutic services, diagnostic services, health informatics, support services, and biotechnology research and development."
                            },
                            {
                                key: "HospitalityAndTourism",
                                displayName: "Hospitality and Tourism",
                                pillText: "Hospitality and Tourism",
                                toolTip: "Managing, marketing and operating restaurants and other food services, lodgings, attractions, recreation events and travel-related services."
                            },
                            {
                                key: "HumanServices",
                                displayName: "Human Services",
                                pillText: "Human Services",
                                toolTip: "Preparing individuals for employment in career pathways that relate to families and human needs."
                            },
                            {
                                key: "InformationTechnology",
                                displayName: "Information Technology",
                                pillText: "Information Technology",
                                toolTip: "Designing, developing, supporting and managing hardware, software, multimedia and system integration services."
                            },
                            {
                                key: "LawPublicSafetyCorrectionsSecurity",
                                displayName: "Law, Public Safety, Corrections and Security",
                                pillText: "Law, Public Safety, Corrections and Security",
                                toolTip: "Planning, managing and providing legal, public safety, protective and homeland security services, including professional and technical support services."
                            },
                            {
                                key: "Manufacturing",
                                displayName: "Manufacturing",
                                pillText: "Manufacturing",
                                toolTip: "Planning, managing and performing the processing of materials into intermediate or final products, including related professional and technical support activities such as production planning and control, maintenance and manufacturing/process engineering."
                            },
                            {
                                key: "Marketing",
                                displayName: "Marketing",
                                pillText: "Marketing",
                                toolTip: "Planning, managing and performing marketing activities to reach organizational objectives."
                            },
                            {
                                key: "ScienceTechEngineeringMath",
                                displayName: "Science, Technology, Engineering and Mathematics",
                                pillText: "Science, Technology, Engineering and Mathematics",
                                toolTip: "Planning, managing and providing scientific research and professional and technical services (such as physical science, social science, engineering), including laboratory and testing services, and research and development services."
                            },
                            {
                                key: "TransportationDistributionLogistics",
                                displayName: "Transportation, Distribution and Logistics",
                                pillText: "Transportation, Distribution and Logistics",
                                toolTip: "Planning, managing and moving people, materials and goods by road, pipeline, air, rail and water, including related professional and technical support services such as transportation infrastructure planning and management, logistics services, mobile equipment and facility maintenance."
                            },
                        ]
                    },
                    major: {
                        key: "Major",
                        category: "Academics",
                        filters: [
                            {
                                pillText: "",
                                key: "MajorName",
                                value: ""
                            },
                            {
                                pillText: "",
                                key: "ProgramName",
                                value: ""
                            }
                        ]
                    },
                    specialPrograms: {
                        key: "SpecialPrograms",
                        category: "Academics",
                        filters: [
                            {
                                pillText: "Accelerated study",
                                displayName: "Accelerated study",
                                key: "AcceleratedStudy"
                            }, {
                                pillText: "Distance learning",
                                displayName: "Distance learning",
                                key: "DistanceLearning"
                            }, {
                                pillText: "Double majors",
                                displayName: "Double majors",
                                key: "DoubleMajors"
                            }, {
                                pillText: "Honors program",
                                displayName: "Honors program",
                                key: "HonorsProgram"
                            }, {
                                pillText: "Independent study",
                                displayName: "Independent study",
                                key: "IndependentStudy"
                            }, {
                                pillText: "Internships",
                                displayName: "Internships",
                                key: "Internships"
                            }, {
                                pillText: "Self-designed majors",
                                displayName: "Self-designed majors",
                                key: "SelfdesignedMajors"
                            }, {
                                pillText: "Study abroad",
                                displayName: "Study abroad",
                                key: "StudyAbroad"
                            }
                        ]
                    }, studentFacultyRatio: {
                        key: "StudentFacultyRatio",
                        category: "Academics",
                        filters: [{
                            pillText: "Student:Faculty",
                            key: "StudentFacultyRatio"
                        }],
                    }, onlineEducation: {
                        key: "OnlineEducation",
                        category: "Academics",
                        filters: [
                            {
                                pillText: "Some online degree programs",
                                displayName: "Some online degree programs",
                                key: "OnlineDegreeCourses"
                            }, {
                                pillText: "All programs available online",
                                displayName: "All programs available online",
                                key: "OnlineDegreePrograms"
                            }, {
                                pillText: "Entirely online school",
                                displayName: "Entirely online school",
                                key: "EntirelyOnlineSchool"
                            }
                        ]
                    }
                },
                interCollegiateSports: {
                    sports: {
                        key: "Sports",
                        category: "Sports",
                        sport: {
                            key: "Sport",
                            filter: {
                                pillText: "Sports",
                                key: "Sport"
                            }
                        },
                        sportsGender: {
                            key: "SportsGender",
                            filter: {
                                key: "SportsGender",
                            }
                        },
                        sportsDivision: {
                            key: "SportsDivision",
                            filter: {
                                key: "SportsDivision"
                            }
                        },
                        scholarshipsAvailable: {
                            key: "ScholarshipsAvailable",
                            filters: [
                                {
                                    key: "ScholarshipsAvailable",
                                    displayName: "Scholarships Available"
                                }
                            ]
                        },
                        selected: false
                    }
                },
                campusLife: {
                    extraCurricular: {
                        key: "ExtraCurricular",
                        category: "CampusLife",
                        filters: [
                            {
                                pillText: "Student newspaper",
                                displayName: "Student newspaper",
                                key: "StudentNewspaper"
                            }, {
                                pillText: "Radio station",
                                displayName: "Radio station",
                                key: "RadioStation"
                            }, {
                                pillText: "Television station",
                                displayName: "Television station",
                                key: "TelevisionStation"
                            }, {
                                pillText: "Fraternities",
                                displayName: "Fraternities",
                                key: "Fraternities"
                            }, {
                                pillText: "Sororities",
                                displayName: "Sororities",
                                key: "Sororities"
                            }, {
                                pillText: "Club/Intramural sports",
                                displayName: "Club/Intramural sports",
                                key: "ClubIntramuralSports"
                            }, {
                                displayName: "ROTC",
                                key: "ROTC",
                                filters: [
                                    {
                                        pillText: "ROTC",
                                        key: "ArmyROTC"
                                    },
                                    {
                                        pillText: "ROTC",
                                        key: "NavyROTC"
                                    },
                                    {
                                        pillText: "ROTC",
                                        key: "AirForceROTC"
                                    }
                                ]
                            }, {
                                pillText: "Music (Performing Arts)",
                                displayName: "Music (Performing Arts)",
                                key: "Music"
                            }
                        ]
                    }, studentHousing: {
                        key: "StudentHousing",
                        category: "CampusLife",
                        filters: [
                            {
                                pillText: "Men-only Housing",
                                displayName: "Men-only",
                                key: "Menonly"
                            }, {
                                pillText: "Women-only Housing",
                                displayName: "Women-only",
                                key: "Womenonly"
                            }, {
                                pillText: "Coed residence halls",
                                displayName: "Coed residence halls",
                                key: "CoedDorms"
                            }, {
                                pillText: "Cooperative housing",
                                displayName: "Cooperative housing",
                                key: "CoopHouse"
                            }, {
                                displayName: "Fraternity/Sorority housing (NC only)",
                                key: "GreekHousing",
                                filters: [
                                    {
                                        pillText: "Fraternity/Sorority housing",
                                        key: "FraternityHousingAvailable"
                                    }, {
                                        pillText: "Fraternity/Sorority housing",
                                        key: "SororityHousingAvailable"
                                    }
                                ]
                            }, {
                                displayName: "Fraternity/Sorority housing",
                                pillText: "Fraternity/Sorority housing",
                                key: "FraternityHousingAvailable"
                            }, {
                                displayName: "Fraternity/Sorority housing",
                                pillText: "Fraternity/Sorority housing",
                                key: "SororityHousingAvailable"
                            }, {
                                pillText: "Special housing",
                                displayName: "Special housing",
                                key: "SpecialHousing"
                            }
                        ]
                    }, additionalServices: {
                        key: "AdditionalServices",
                        category: "CampusLife",
                        filters: [
                            {
                                pillText: "Daycare",
                                displayName: "Daycare (NC only)",
                                key: "DayCare"
                            }, {
                                pillText: "Alcohol/Substance abuse counseling",
                                displayName: "Alcohol/Substance abuse counseling (NC only)",
                                key: "AbuseCounseling"
                            }, {
                                pillText: "Personal/Psychological counseling",
                                displayName: "Personal/Psychological counseling",
                                key: "PsychCounseling"
                            }, {
                                pillText: "Health services",
                                displayName: "Health services",
                                key: "HealthServices"
                            }, {
                                displayName: "Learning assistance services",
                                pillText: "Learning assistance services",
                                key: "LearningDisabled"
                            }, {
                                pillText: "Work study",
                                displayName: "Work study",
                                key: "WorkStudy"
                            }
                        ]
                    }
                },
                additionalFilters: {
                    state: {
                        key: "State",
                        filters: [
                            {
                                key: "State",
                            }
                        ]
                    },
                    name: {
                        key: "Name",
                        filter: {
                            key: "Name"
                        }
                    }
                }
            }
            return filters;
        }
    }

    angular.module("app").factory(CampusSearchDataService.serviceId, ["Restangular", "common", "$http", (Restangular: Restangular.IService, common: ICommonFactory, $http: ng.IHttpService) => new CampusSearchDataService(Restangular, common, $http)]);
}